import Vue from 'vue';
import VueRouter from 'vue-router';
import DashBoard from '../views/DashBoard.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'name',
		component: DashBoard,
	},
	{
		path: '/login',
		name: 'login',
		component: () => import(/* webpackChunkName: "about" */ '../views/login.vue'),
	},
	{
		path: '/Register',
		name: 'Register',
		component: () => import(/* webpackChunkName: "about" */ '../views/Register/index.vue'),
	},
	{
		path: '/ForgotPassword',
		name: 'ForgotPassword',
		component: () => import(/* webpackChunkName: "about" */ '../views/ForgotPassword/index.vue'),
	},
	{
		path: '/about',
		name: 'about',
		component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
	},
	{
		path: '/proFile',
		name: 'proFile',
		component: () => import(/* webpackChunkName: "about" */ '../views/proFile.vue'),
	},
	{
		path: '/subscripTion',
		name: 'subscripTion',
		component: () => import(/* webpackChunkName: "about" */ '../views/subscripTion.vue'),
	},
	{
		path: '/hisTory',
		name: 'hisTory',
		component: () => import(/* webpackChunkName: "about" */ '../views/hisTory.vue'),
	},
	{
		path: '/contAct',
		name: 'contAct',
		component: () => import(/* webpackChunkName: "about" */ '../views/contAct.vue'),
	},
	{
		path: '/autoBooking',
		name: 'autoBooking',
		component: () => import(/* webpackChunkName: "about" */ '../views/autoBooking.vue'),
	},
	{
		path: '/LiveSlots',
		name: 'LiveSlots',
		component: () => import(/* webpackChunkName: "about" */ '../views/LiveSlots.vue'),
	},
	{
		path: '/DashBoardcopy',
		name: 'DashBoardcopy',
		component: () => import(/* webpackChunkName: "about" */ '../views/DashBoardcopy.vue'),
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

export default router;
